import _, { get, isEqual } from "lodash";
import { PropertyPaths } from "./typeHelpers";

export const objectsMatchProperties = <T extends Record<string, unknown>, U extends T>(objA: T, objB: U, paths: PropertyPaths<T>[]) => {
	for (const path of paths) {
		const pathArray = path.split(".");
		const valA = get(objA, pathArray);
		const valB = get(objB, pathArray);
		if (!isEqual(valA, valB)) {
			return false;
		}
	}
	return true;
};

export const cleanEmptyValues = (input: unknown): unknown => {
	if (!input) {
		return undefined;
	}

	if (_.isArray(input)) {
		const cleanedArray = input.map(cleanEmptyValues).filter((item) => (_.isArray(item) ? item.length > 0 : !_.isEmpty(item)));
		return cleanedArray.length ? cleanedArray : undefined;
	}

	if (_.isPlainObject(input)) {
		const cleanedObject = _.transform(
			input,
			(result, value, key) => {
				const cleanedValue = cleanEmptyValues(value);
				if (cleanedValue !== undefined && !_.isEmpty(cleanedValue)) {
					result[key] = cleanedValue;
				}
			},
			{} as Record<string, unknown>
		);
		return _.isEmpty(cleanedObject) ? undefined : cleanedObject;
	}

	return input;
};
